'use strict';

// Localisations
// ============
module.exports = {
  en: {
    menuguest: [{
      title: 'Home',
      link: '/',
      startGroup: false
    }, {
      title: 'Signup',
      link: '/signup',
      startGroup: false
    }, {
      title: 'Login',
      link: '/login',
      endGroup: false
    }, {
      title: 'T&Cs',
      link: '/terms',
      endGroup: true
    }],
    menuuser: [{
      title: 'Pre Survey',
      link: 'https://docs.google.com/forms/d/1W6HERCp1Ge05F70k2euO2vZFNmHi3vrdztyxFynyAG4/edit?ts=6641ccd3',
      startGroup: true,
      endGroup: false,
      newWindow: true
    }, {
      title: 'Post Survey',
      link: 'https://docs.google.com/forms/d/1Ddoc5iV69VQJ86iCjCUkkmAdhIT9HvArGUCkY8Csu1g/edit?ts=6641ccc3',
      startGroup: false,
      endGroup: true,
      newWindow: true
    }, {
      title: 'Messages',
      link: '/messages',
      startGroup: true,
      endGroup: true,
      newWindow: false
    }, {
      title: 'Settings',
      link: '/settings',
      startGroup: false,
      startGroupVert: false,
      newWindow: false
    }, {
      title: 'Logout',
      link: '/logout',
      endGroup: false,
      newWindow: false
    }, {
      title: 'T&Cs',
      link: '/terms',
      endGroup: true,
      newWindow: false
    }],
    menuadmin: [{
      title: 'Users',
      link: '/users',
      startGroup: false,
      startGroupVert: false,
      endGroup: false
    }, {
      title: 'PM',
      link: '/passwords',
      startGroup: false,
      startGroupVert: false,
      endGroup: false
    }],
    menumoderate: [{
      title: 'Settings',
      link: '/settings',
      startGroup: false,
      startGroupVert: false
    }, {
      title: 'Logout',
      link: '/logout',
      endGroup: false
    }, {
      title: 'T&Cs',
      link: '/terms',
      endGroup: true
    }, {
      title: 'Group Admin',
      link: '/allgroups',
      startGroup: false,
      startGroupVert: false,
      endGroup: true
    }],
    notificationlink: 'Notifications',
    markallread: 'Mark All Read',
    cancel: 'Close Notifications',
    view: 'view'
  },
  es: {

  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/components/common/menu.localisations.js